import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import ProfileHeaderCard from "../../components/ProfileHeaderCard";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import AddEventModal from "../../components/AddEventModal";
import {setEventsCounts, onPresAddEvent} from "../../actions";
import trLocale from '@fullcalendar/core/locales/tr';
import {apiCall} from "../../helpers/MainHelper";
import EventDetailModel from "../../components/EventDetailModel";
import ReactLoading from "react-loading";
import {openModal} from "../../actions";

class AppCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user:[],
      events:[],
      eventsCountsData:[],
      isLoad:true,
      isModalOpen: false,
      selectedEvent:null,

    }
  }
  componentDidMount() {
    this.getEvents();
    window.scrollTo(0, 0);

  }
  getEvents = async () => {
    try {
      const response = await apiCall('business/events/all','get',null);
      const formattedEvents = response.events.map(event => ({
        id: event.id,
        title: event.title,
        description: event.description,
        start: event.start.replace(' ', 'T'),
        end: event.end.replace(' ', 'T'),
        extendedProps: {
          description: event.description,
          status: event.status,
        }
      }));
      this.setState({events:formattedEvents,eventsCounts:response.eventsCounts},() => {
        this.props.setEventsCounts(response.eventCounts);
      });
      this.setState({isLoad:false})
    }catch (e) {
      this.setState({isLoad:false})
    }

  }
  handleEventClick = (info) => {

    this.props.openModal({
      id: info.event.id,
      title: info.event.title,
      start: info.event.start.toISOString(),
      end: info.event.end.toISOString(),
      allDay: false,
      description: info.event.extendedProps.description,
      status: info.event.extendedProps.status,
    });
  };
  closeModal = () => {
    this.setState({ isModalOpen: false });
  };
  eventRender = (info) => {
    if (info.event.extendedProps.status === 'Tamamlandı') {
      const element = info.el;
      element.style.textDecoration = 'line-through';
      element.style.color = 'white';
      element.style.backgroundColor = 'red';
    }
  };
  render() {
    const {isEventModal} = this.props;
    const {isLoad, events, isModalOpen} = this.state;

    return (
        <div onClick={() => {
          document.body.classList.remove("offcanvas-active");
      }} style={{ flex: 1 }}>
        <div style={{ opacity: isEventModal ? 0.3 : 1 }}>
          <div className="ng-star-inserted">
            <div className="container-fluid">
              <PageHeader
                  HeaderText="Takvim"
                  Breadcrumb={[{name: "Uygulamalar"}, {name: "Takvim"}]}
                  key="1"
              />
              <div className="page-loader-wrapper" style={{display: this.state.isLoad ? 'block' : 'none'}}>
                <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                  <div className="m-t-30">
                    <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid"/>
                  </div>
                  <p>Yükleniyor</p>
                  <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
                </div>
              </div>
              <div className="row clearfix">
                <div className="col-lg-8">
                  <div className="card">
                    <div className="body">
                      <FullCalendar
                          defaultView="dayGridMonth"
                          header={{
                            left: "prev,next today",
                            center: "title",
                            right:
                                "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
                          }}
                          plugins={[
                            dayGridPlugin,
                            timeGridPlugin,
                            interactionPlugin,
                            listPlugin,
                          ]}
                          events={events}
                          eventRender={this.eventRender}
                          eventClick={this.handleEventClick}
                          locale={trLocale}
                          eventTimeFormat={{
                            hour: '2-digit',
                            minute: '2-digit',
                            meridiem: false,
                            hour12: false
                          }}

                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="card">
                    <div className="body">
                      <button
                          type="button"
                          onClick={() => {
                            this.props.onPresAddEvent();
                            //document.body.classList.add('modal-open');
                          }}
                          className="btn btn-outline-primary btn-block"
                          data-toggle="modal"
                          data-target="#addevent"
                      >
                        Yeni Etkinlik
                      </button>
                    </div>
                  </div>
                  <div className="card profile-header">
                    <ProfileHeaderCard
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddEventModal getEvents={this.getEvents}/>
        {isLoad && (
            <EventDetailModel
                isOpen={isModalOpen}
            />
        )}

      </div>
    );
  }
}

const mapStateToProps = ({mailInboxReducer}) => ({
  isEventModal: mailInboxReducer.isEventModal,
  isModalOpen: mailInboxReducer.isModalOpen,
});

export default connect(mapStateToProps, {onPresAddEvent,openModal,setEventsCounts})(AppCalendar);
